namespace TabAurous.Production {
    export interface JobWorkReceiptItemsForm {
        FromDeptId: Serenity.LookupEditor;
        BagNo: Serenity.StringEditor;
        ProcessId: MFGProcessLookup;
        QualityInspection: MFGInspectionValuesEditor;
        SubBagNo: Serenity.IntegerEditor;
        ProductCode: Serenity.StringEditor;
        Line_No: Serenity.StringEditor;
        FromPieces: Serenity.IntegerEditor;
        OrderNo: Serenity.StringEditor;
        FromWeight: WeightEditor;
        CustomerName: Serenity.StringEditor;
        FromNetWeight: WeightEditor;
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        Attribute: Serenity.StringEditor;
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        QualityInspectionValue: _Ext.YesNoEditor;
        Button: ButtonEditor;
        BOMDetails: JobWorkReceiptBOMEditor;
        NewBOMDetails: MaterialInJobWork;
        LaborDetails: JobWorkReceiptLaborEditor;
        PureWeight: WeightEditor;
        Purity: Serenity.DecimalEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        TransId: Serenity.StringEditor;
        RefVoucherId: Serenity.IntegerEditor;
        RefTransId: Serenity.StringEditor;
        RefTransItemId: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        OrderTypeId: Serenity.IntegerEditor;
        OrderTransId: Serenity.IntegerEditor;
        OrderTransItemId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        DepartmentId: Serenity.LookupEditor;
        TreeId: Serenity.StringEditor;
        TreeItemId: Serenity.StringEditor;
        TreeNo: Serenity.StringEditor;
        Parts: Serenity.IntegerEditor;
    }

    export class JobWorkReceiptItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Production.JobWorkReceiptItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!JobWorkReceiptItemsForm.init)  {
                JobWorkReceiptItemsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = MFGProcessLookup;
                var w3 = MFGInspectionValuesEditor;
                var w4 = s.IntegerEditor;
                var w5 = WeightEditor;
                var w6 = s.DateEditor;
                var w7 = _Ext.YesNoEditor;
                var w8 = ButtonEditor;
                var w9 = JobWorkReceiptBOMEditor;
                var w10 = MaterialInJobWork;
                var w11 = JobWorkReceiptLaborEditor;
                var w12 = s.DecimalEditor;

                Q.initFormType(JobWorkReceiptItemsForm, [
                    'FromDeptId', w0,
                    'BagNo', w1,
                    'ProcessId', w2,
                    'QualityInspection', w3,
                    'SubBagNo', w4,
                    'ProductCode', w1,
                    'Line_No', w1,
                    'FromPieces', w4,
                    'OrderNo', w1,
                    'FromWeight', w5,
                    'CustomerName', w1,
                    'FromNetWeight', w5,
                    'TransDate', w6,
                    'VoucherNo', w1,
                    'Attribute', w1,
                    'ProductId', w1,
                    'AttributeId', w1,
                    'QualityInspectionValue', w7,
                    'Button', w8,
                    'BOMDetails', w9,
                    'NewBOMDetails', w10,
                    'LaborDetails', w11,
                    'PureWeight', w5,
                    'Purity', w12,
                    'CompanyId', w4,
                    'FinancialYearId', w4,
                    'TransId', w1,
                    'RefVoucherId', w4,
                    'RefTransId', w1,
                    'RefTransItemId', w1,
                    'VoucherTypeId', w4,
                    'OrderTypeId', w4,
                    'OrderTransId', w4,
                    'OrderTransItemId', w4,
                    'UserId', w4,
                    'DepartmentId', w0,
                    'TreeId', w1,
                    'TreeItemId', w1,
                    'TreeNo', w1,
                    'Parts', w4
                ]);
            }
        }
    }
}
